import React, { Fragment } from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

import Label from './Label';
import BetweenLabel from './BetweenLabel';

import SearchIcon from '@material-ui/icons/Search';

import { AppState } from '../../../appredux';

import { connect } from 'react-redux';
import { Button } from '@material-ui/core';

export interface MuiTextFieldProps {
    key: string | number,
    value: string | number,
    dirtyBackground?: string,
    completed?: boolean,
    type?: string,
    formControlStyle?: React.CSSProperties,
    label?: string,
    betweenLabel?: string,
    labelSecondary?: boolean,
    labelBold?: boolean,
    labelBlock?: boolean,
    labelStyle?: React.CSSProperties,
    labelClasses?: string,
    style?: React.CSSProperties,
    className?: string,
    inputClasses?: string,
    endAdornment?: JSX.Element,
    disabled?: boolean,
    onChange?: (event: React.ChangeEvent<{
        name?: string;
        value: unknown;
    }>) => void,
    onSearch?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    button?: string,
    onButtonClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    placeholder?: string,
    err?: string,
    autoFocus?: boolean,
}

interface MuiTextFieldState {
    selected: boolean
}

class MuiTextField extends React.Component<MuiTextFieldProps & WithStyles<typeof styles>, MuiTextFieldState> {

    constructor(props: MuiTextFieldProps & WithStyles<typeof styles>) {
        super(props);
        this.state = { selected: false };
    }

    componentDidUpdate(prevProps: MuiTextFieldProps & WithStyles<typeof styles>) {
        if (!this.state.selected && prevProps.value !== this.props.value)
            this.setState({ selected: true });
    }

    textField = () => {
        const classes = this.props.classes;

        let InputProps: any = { classes: { input: this.props.inputClasses }, };

        if (this.props.endAdornment)
            InputProps = {
                ...InputProps, endAdornment: this.props.endAdornment, style: ((this.state.selected || this.props.completed) && this.props.value) || this.props.disabled
                    ? { backgroundColor: this.props.dirtyBackground } : {}
            };

        return (
            <Fragment>
                <TextField
                    type={this.props.type ? this.props.type : 'text'}
                    key={this.props.key}
                    className={this.props.className} style={this.props.style}
                    variant="outlined"
                    inputProps={{
                        style: ((this.state.selected || this.props.completed) && this.props.value) || this.props.disabled
                            ? { backgroundColor: this.props.dirtyBackground } : {}
                    }}
                    InputProps={InputProps}
                    value={this.props.value} disabled={this.props.disabled}
                    onChange={this.props.onChange}
                    autoFocus={this.props.autoFocus}
                    placeholder={this.props.placeholder}
                    error={this.props.err === undefined || this.props.err === "" ? false : true}
                    helperText={this.props.err}
                />
                {this.props.onSearch && (String(this.props.value).length > 2 ?
                    <button className={`${classes.searchButton} ${classes.backgroundSecondary}`}
                        type="button"
                        onClick={this.props.onSearch}>
                        <SearchIcon className={classes.icon} />
                    </button>
                    :
                    <button className={classes.searchButton}
                        disabled>
                        <SearchIcon className={classes.icon} />
                    </button>)
                }
                {this.props.button ?
                    <Button color='primary' variant='outlined' size='small' onClick={this.props.onButtonClick} className={classes.button}>
                        {this.props.button}
                    </Button> : null}
            </Fragment>
        )
    }

    render() {
        const classes = this.props.classes;

        return (
            <Fragment>
                <FormControl
                    variant="outlined" margin="normal" fullWidth
                    className={classes.formControl}
                    style={this.props.formControlStyle}
                >

                    {this.props.betweenLabel ?
                        <BetweenLabel
                            label={this.props.betweenLabel}
                            secondary={this.props.labelSecondary}
                        />
                        :
                        <Label
                            label={this.props.label}
                            secondary={this.props.labelSecondary}
                            bold={this.props.labelBold}
                            block={this.props.labelBlock}
                            style={this.props.labelStyle}
                            className={this.props.labelClasses}
                        />
                    }
                    {this.textField()}
                </FormControl>
            </Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    formControl: {
        marginTop: "0px",
        display: "block",
        //paddingBottom: "35px"
    },
    searchButton: {
        padding: "6px 8px 5px",
        lineHeight: "13px",
        textAlign: "center" as "center",
        textTransform: "lowercase" as "lowercase",
        margin: "3px",
        width: "9%",
        height: "35px",
        border: "none",
        color: "white",
        borderRadius: "4px",
        boxShadow: "0 2px 2px rgba(0,0,0,.2)",
        textDecoration: "none",
        fontWeight: 100,
        fontSize: "24px",
        cursor: "pointer",
        display: "inline-block"
    },
    backgroundSecondary: {
        background: theme.palette.secondary.main
    },
    icon: {
        verticalAlign: "middle"
    },
    button: {
        textTransform: 'lowercase' as 'lowercase',
        marginLeft: '8px',
        marginTop: '2.5px',
    }
});

const mapStateToProps = (state: AppState) => ({
    dirtyBackground: state.pageState.secondaryLight
});

export default connect(mapStateToProps)(withStyles(styles)(MuiTextField));